module.exports = __webpack_public_path__ + "img/mobile-scan.a7df1039.svg";